// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

import Sortable from '../Sortable';
import Loading from 'react-loading';

import api from '../../api';
import formatDate from '../../utilities/formatDate';

import '../../styles/scripts.css';
import '../../styles/files.css';
import Checkbox from '../Checkbox';

export default class Scripts extends React.Component {

    prebuilt = () => [{
        name: "Nightly Trust Accounting",
        running: this.props.team?.ta?.running,
        enabled: this.props.team?.ta?.enabled,
        lastRun: this.props.team?.ta?.lastRun,
        setEnabled: (enabled) => {
            this.props.updateTeam({
                ta: {
                    ...this.props.team?.ta,
                    enabled
                }
            });
        }
    }]

    componentDidMount = async () => {
        const res = await api.get('/script/all');
        if (res && res.scripts)
            this.props.setScripts(res.scripts);
    }

    runScript = (event, script) => {
        event.stopPropagation();
        event.preventDefault();
        this.props.runScript(script);
    }

    clearError = (event, script) => {
        event.stopPropagation();
        event.preventDefault();
        this.props.clearError(script);
    }

    editScript = (event, script) => {
        event.stopPropagation();
        event.preventDefault();
        this.props.modal('edit-script', { script });
    }

    deleteScript = async (event, script) => {
        event.stopPropagation();
        event.preventDefault();

        await this.props.loading();
        await api.get(`/script/remove?scriptId=${script._id}`);

        // Remove locally
        let scripts = [ ...this.props.scripts ];
        const scriptx = scripts.findIndex(f => f._id === script._id);

        if (scriptx >= 0)
            scripts.splice(scriptx, 1);

        this.props.setScripts(scripts);
        this.props.loaded();
    }

    render = () => {
        return (<div className="settings-content">
            
            <p>
                You can use <strong>scripts</strong> to automatically run code on a pre-defined schedule. This can be used to run scripts to process data from other sources, send reminder emails, etc.<br /><br /><strong>NOTE:</strong> Your account may be deleted if you abuse scripts to run anything other that necessary code to process documents in Stax·ai.
            </p>

            <div style={{ clear: 'both' }} />

            <h2 style={{ paddingLeft: 20, fontWeight: 600, paddingBottom: 0 }}>Prebuilt Automations</h2>

            <Sortable
                title={null}
                data={this.prebuilt()}

                // Default sort
                defaultSortBy="name"
                defaultSortDir={1}

                // Header configuration
                header={{
                    name: {
                        prop: "name",
                        label: "Descrpiption"
                    },
                    meta: [
                        {
                            prop: "enabled",
                            label: "Enabled",
                            width: 140
                        },
                        {
                            prop: "lastRun",
                            label: "Last Run At",
                            width: 140
                        },
                    ]
                }}

                // Line item renderer
                renderItem={(script, idx, renderMeta) => <div className="scripts-list-column" key={idx}>
                    <div className="scripts-list-item">
                        <div className="scripts-list-name">
                            {script.name}
                        </div>

                        <div className="stack-list-meta">
                            {renderMeta(<Checkbox
                                label="Enabled"
                                className="scripts-checkbox"
                                checked={script.enabled}
                                onToggle={() => script.setEnabled(!script.enabled)}
                            />, 145)}
                            {renderMeta(script.running ? <div className="scripts-running-container">
                                <div className="scripts-running-icon">
                                    <Loading
                                        type="spin"
                                        color="var(--color-primary)"
                                        height={24}
                                        width={24}
                                    />
                                </div>
                                <div className="scripts-running-text">Running...</div>
                            </div> : formatDate(script.lastRun), 150)}
                        </div>
                    </div>

                </div>}
            />

            <h2 style={{ paddingLeft: 20, fontWeight: 600, paddingBottom: 0 }}>My Custom Scripts<div className="settings-add" onClick={() => this.props.modal("create-script")}>＋ Create new script</div></h2>

            <Sortable
                title={null}
                data={this.props.scripts}

                // Default sort
                defaultSortBy="name"
                defaultSortDir={1}

                // Header configuration
                header={{
                    name: {
                        prop: "name",
                        label: "Script name"
                    },
                    meta: [
                        {
                            prop: "lastRun",
                            label: "Last Run At",
                            width: 140
                        },
                        {
                            prop: "lastModified",
                            label: "Last Modified",
                            width: 140
                        },
                        {
                            prop: "",
                            label: "",
                            width: 172
                        }
                    ]
                }}

                // Line item renderer
                renderItem={(script, idx, renderMeta) => <div className="scripts-list-column" key={idx}>
                    <div className="scripts-list-item">
                        <div className="scripts-list-name">
                            {script.name}
                            <img
                                className="scripts-list-language"
                                alt={script.language}
                                src={"https://static.stax.ai/images/language/" + script.language + ".png"}
                            />
                        </div>

                        <div className="stack-list-meta">
                            {renderMeta(script.running ? <div className="scripts-running-container">
                                <div className="scripts-running-icon">
                                    <Loading
                                        type="spin"
                                        color="var(--color-primary)"
                                        height={24}
                                        width={24}
                                    />
                                </div>
                                <div className="scripts-running-text">Running...</div>
                            </div> : formatDate(script.lastRun), 140)}
                            {renderMeta(formatDate(script.lastModified), 140)}
                            {renderMeta(<div style={{ float: 'right', marginTop: 10 }}>
                                {script.running ? "" : <div
                                    className="scripts-list-action"
                                    onClick={(event) => this.runScript(event, script)}
                                >Run</div>}
                                <div
                                    className="scripts-list-action"
                                    onClick={(event) => this.editScript(event, script)}
                                >Edit</div>
                                <div
                                    className="scripts-list-action scripts-list-action-delete"
                                    onClick={(event) => this.deleteScript(event, script)}
                                >Delete</div>
                            </div>, 180)}
                        </div>
                    </div>

                    { !script.source ? <div className="scripts-warning">
                        <em>Warning: no source specified!</em>
                    </div> : null}

                    { script.failed ? <div className="scripts-warning scripts-error">
                        <em>Error: {script.error}</em>
                        <div className='scripts-clear-error'>
                            { script.failed ? <div className="scripts-list-action"
                                onClick={(event) => this.clearError(event, script)}
                            >Clear Error</div> : null}
                        </div>
                    </div> : null}

                </div>}
            />
        </div>);
    }

};